// removed by extract-text-webpack-plugin
module.exports = {"container":"GalleryPhotoContainer-style__container__993596ac"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoContainer-style.scss
// module id = 1032
// module chunks = 7 23 26 27